import { TableCell } from "@mui/material";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import { useState } from "react";
import Button from "../../../Components/Button";
import Modal from "../../../Components/Modal/Modal";
import { IDeltaHedgeExeDetailedStateTableReport } from "../../../Interfaces/deltaHedgeExe";
import TradeTable from "./Trade/TradeTable";
// UI Framework
import TimelineIcon from "@mui/icons-material/Timeline";
// Local Components
import ChartUI from "src/Tables/DeltaHedgeAccount/Aggregate/Additional/ChartUI";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
    </>
  );
};

enum ModalMode {
  Trades,
  AdjustmentState,
  Closed,
  Chart,
}

const AdditionalCol: React.FC<{
  row: IDeltaHedgeExeDetailedStateTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [modalMode, setModalMode] = useState(ModalMode.Closed);

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.Trades:
        return <TradeTable id={row.id} />;
      case ModalMode.Chart:
        //@ts-ignore
        return <ChartUI row={row} />;

      case ModalMode.Closed:
        return <></>;
    }
  };

  return (
    <>
      <TableCell>
        {modalMode !== ModalMode.Closed ? (
          <Modal
            UI={getModalUI()}
            onClose={() => setModalMode(ModalMode.Closed)}
            fullScreen={modalMode === ModalMode.Chart}
          />
        ) : (
          <></>
        )}
        <div className="w-16">
          <Button
            text="معاملات"
            variant="contained"
            className="table-btn"
            onClick={() => setModalMode(ModalMode.Trades)}
          />
        </div>
      </TableCell>
      <TableCell>
        <Button
          text={<TimelineIcon className="!text-base" />}
          onClick={() => setModalMode(ModalMode.Chart)}
          variant="contained"
          className="table-btn"
        />
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IDeltaHedgeExeDetailedStateTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
